exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iconMenu{\r\n    width: 21px;\r\n    margin-right: 15px;\r\n    margin-left: 10px;\r\n    vertical-align: middle;\r\n    float: left;\r\n}\r\n\r\n.nav-item-custom{\r\n    width: 100%;\r\n}\r\n\r\n.userAdmin{\r\n    margin-top: 8px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/sidebar/sidebar.component.css
// module id = ../../../../../src/app/core/sidebar/sidebar.component.css
// module chunks = 16